import { render, staticRenderFns } from "./RecipientGroups.vue?vue&type=template&id=33a60252&scoped=true&"
import script from "./RecipientGroups.vue?vue&type=script&lang=js&"
export * from "./RecipientGroups.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33a60252",
  null
  
)

export default component.exports